import { gql } from '@apollo/client'

import { UserFragment } from './user.fragment'
import { OrganizationRBACFragment, ProjectRBACFragment } from './rbac.fragment'

export const MeFragment = gql`
  fragment MeFragment on User {
    ...UserFragment
    organizationACL {
      ...OrganizationRBACFragment
    }
    projectACL {
      ...ProjectRBACFragment
    }
  }
  ${UserFragment}
  ${OrganizationRBACFragment}
  ${ProjectRBACFragment}
`
